import React from 'react';
import {  Modal } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from '../hooks'
import { setShowFaq } from "../redux/reducers/storageSlice";

const FAQ: React.FC = () => {
    const dispatch = useAppDispatch();
    const showFaq = useAppSelector(state => state.storage.showFaq);
    const handleClose = () => dispatch(setShowFaq(false));
    return (
      <Modal show={showFaq} onHide={handleClose} size={"xl"}>
        <Modal.Header closeButton style={{textAlign: "center"}}>
          <Modal.Title style={{textAlign: "center", flex: "auto"}}>F A Q</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <strong><h4 style={{fontWeight: "bold"}}>What is DegenDevil?</h4></strong>
            <br/>
            DegenDevil is a smart contract that allows users to play against different Multipliers with their Solana Tokens.
            <br/><br/><br/>
            <strong><h4 style={{fontWeight: "bold"}}>What are the Multipliers and Odds of Winning?</h4></strong>
            <br/>
            All our Multipliers have true odds with no house edge and are provably fair. 
            <br/><br/>
            Average Win Rates by Multiplier:
            <br/><br/>
            1.33x = 75% Win Chance
            <br/> 
            2x = 50% Win Chance
            <br/> 
            4x = 25% Win Chance
            <br/> 
            10x = 10% Win Chance
            <br/>
            25x = 4% Win Chance
            <br/>            
            <br/><br/>
            For example: a 1 SOL bet placed on the 10x Multiplier would win 10 SOL and has a 10% success rate. 
            <br/><br/><br/>
            <strong><h4 style={{fontWeight: "bold"}}>What are the fees?</h4></strong>
            <br/>
            The fee charged is a % of each bet and depends on the multiplier selected:
            <br/><br/>
            Oracle Fee (Fixed) .0001 SOL
            <br/>
            1.33x = 3%
            <br/>
            2x = 3%
            <br/>
            4x = 4%
            <br/>
            10x = 5.5%
            <br/>
            25x = 6.5%
            <br/>            
            <br/><br/>
            For example a 2x Multiplier 1 SOL Bet will be charged a 0.031 SOL fee
            <br/><br/><br/>
            <strong><h4 style={{fontWeight: "bold"}}>How can I Trust that DegenDevil is Fair?</h4></strong>
            <br/>
            Our #1 priority is transparency. 
            DegenDevil logs all bets with results onchain and uses MixPanel to report the statistics in real time.
            <br/><br/>
            Anyone can view the public statistics links and confirm them against our Treasury Wallet at any time. 
            <br/><br/><br/>
            <strong><h4 style={{fontWeight: "bold"}}>What are the onchain addresses?</h4></strong>
            <br/>
            Program: 
            7ghVtYY5UcpXhhVGB6sSYVo7sWEHzKrDYGf1t2FuNRW2
            <br/><br/>
            Treasury: 
            Had1emGD3qmFRXeBUeBXPQqS8Wi7BLGLAZ7167d4aM1W
            <br/><br/>
            Fee: 
            3z9qkHLuLJGd32LCPGNAXJAVNoAPgpTLdcHNhWQmH3B3
            <br/><br/><br/>
            <strong><h4 style={{fontWeight: "bold"}}>How do I collect my winnings?</h4></strong>
            <br/>
            We use an easy 1-click process. 
            After each bet the winning amount is automatically transferred to your wallet. 
            <br/><br/>
        </Modal.Body>

      </Modal>
    );
};

export default FAQ;